import css from './TnaGeneral.module.css';
import toShort from '../../../../../services/utils/dateParser';

import DetailsGeneral from '../../../_common/elements/details/DetailsGeneral';

function TnaGeneral({ tnaDetails, toggleModal, totalDuration, minutesToDuration, totalMcq, lockData }) {
    let content = {};
    let functions = {};

    // console.log(tnaDetails);

    content.info = [
        <p key={1}>
            Ref: <strong>{tnaDetails?.tnaNo}</strong>
        </p>,
        <p key={2}>
            Aircraft type: <strong>{tnaDetails?.aircraftType}</strong>
        </p>,
        <p key={3}>
            Cat.: <strong>{tnaDetails?.licenseCategory}</strong>
        </p>,
        <p key={4}>
            Rev.: <strong>{tnaDetails?.tnaRev}</strong>
        </p>,
        <p key={5}>
            Date: <strong>{tnaDetails?.tnaRevDate}</strong>
        </p>,
    ];

    content.notes = (
        <>
            <p className={css.notes} style={{ fontSize: '1rem' }}>
                <strong>Description:</strong>
                <br />
                {tnaDetails?.tnaDescription}
            </p>
            <p className={css.notes} style={{ fontSize: '1rem' }}>
                <strong>Terminal LO:</strong>
                <br />
                {tnaDetails?.tnaTerminalLO}
            </p>
            <p className={css.notes} style={{ fontSize: '1rem' }}>
                <strong>Prerequisites:</strong>
                <br />
                {tnaDetails?.tnaPrerequisites}
            </p>
            <p className={css.notes} style={{ fontSize: '1rem' }}>
                <strong>Ref documents:</strong>
                <br />
                {tnaDetails?.tnaReferenceDocuments}
            </p>
            <p className={css.notes} style={{ fontSize: '1rem' }}>
                <strong>Notes:</strong>
                <br />
                {tnaDetails?.tnaModuleNote}
            </p>
        </>
    );

    // at the moment it is only one option per student, if there are more in the future, this needs to be changed
    content.options = '';
    content.additional = (
        <div className={css.qr}>
            <p>
                Total Duration: <strong>{minutesToDuration(totalDuration)} hours (~{Math.ceil(totalDuration / (60 * Number(tnaDetails?.tnaMaxDayHours)))} days)</strong>
            </p>

            <p>
                Min att:{' '}
                <strong>
                    {tnaDetails?.tnaMinAttendance}% (
                    {minutesToDuration(Math.ceil((totalDuration * Number(tnaDetails?.tnaMinAttendance)) / 100))}
                    hrs)
                </strong>
            </p>
            <p>
                Total MCQ: <strong>{totalMcq}</strong>
            </p>
            <p>
                Max day hours: <strong>{tnaDetails?.tnaMaxDayHours} hrs</strong>
            </p>

            <p>
                Created: <strong>{toShort(tnaDetails?.tnaCreated)}</strong>
            </p>
            <p>
                Updated: <strong>{toShort(tnaDetails?.tnaModified)}</strong>
            </p>
            <button className={css.lockButton} onClick={lockData.handleLockButton}>
                Lock
            </button>
        </div>
    );

    functions.edit = toggleModal;

    return <DetailsGeneral content={content} functions={functions} />;
}
export default TnaGeneral;
